/** 表格列宽与横向滚动 */

const DEFAULT_COL_WIDTH = 120

const TITLE_WIDTH_RULES = [
  { test: (col) => col.key === 'action' || (col.title && String(col.title).indexOf('操作') >= 0), width: 180 },
  { test: (col) => /名称|客户|商机|项目|合同|物料|代理商/.test(String(col.title || '')), width: 180 },
  { test: (col) => /编号|编码|单号/.test(String(col.title || '')), width: 140 },
  { test: (col) => /日期|时间|跟进/.test(String(col.title || '')), width: 120 },
  { test: (col) => col.align === 'right' || /金额|回款|应收|毛利|率|数量/.test(String(col.title || '')), width: 120 },
  { test: (col) => /阶段|状态|类型|来源|行业/.test(String(col.title || '')), width: 100 }
]

export function guessColumnWidth(col) {
  if (col.width) return col.width
  if (col.minWidth) return col.minWidth
  for (let i = 0; i < TITLE_WIDTH_RULES.length; i++) {
    const rule = TITLE_WIDTH_RULES[i]
    if (rule.test(col)) return rule.width
  }
  return DEFAULT_COL_WIDTH
}

export function formatCellValue(text) {
  if (text == null || text === '') return '—'
  if (typeof text === 'object') return '—'
  return text
}

/**
 * 补全列宽与 ellipsis，保留 scopedSlots 供 a-table 原生渲染（兼容 1.x 固定列/横向滚动）。
 */
export function normalizeTableColumns(columns) {
  if (!columns || !columns.length) return []
  return columns.map((col) => {
    return Object.assign({}, col, {
      width: guessColumnWidth(col),
      ellipsis: col.ellipsis !== false
    })
  })
}

export function calcTableScrollX(columns) {
  if (!columns || !columns.length) return 960
  let total = 0
  columns.forEach((col) => {
    total += col.width || col.minWidth || DEFAULT_COL_WIDTH
  })
  return Math.max(total + 48, 960)
}
